<script>
    import { Line, mixins } from 'vue-chartjs'
    export default {
        mounted() {
          if (this.chartData) this.renderChart(this.chartData, this.options)
        },
        props: ['chartData','distribution', 'stacked'],
        extends: Line,
        mixins: [mixins.reactiveProp],
        watch: {
            distribution () {
                this.options.scales.xAxes = [{
                    type: 'time',
                    distribution: this.distribution ? this.distribution : 'linear',
                    ticks: {
                      source:'data',
                    },
                }]
              if (this.chartData) this.renderChart(this.chartData, this.options);
            },
            chartData() {
                this.renderChart(this.chartData, this.options);
            }
        },
        data() {
            return {
                options: {
                    animation: false,
                    responsive: true,
                    // Can't just just `stacked: true` like the docs say
                    scales: {
                        xAxes: [{
                            type: 'time',
                            distribution: this.distribution ? this.distribution : 'linear',
                            ticks: {
                              source:'data',
                            },
                        }],
                        yAxes: [{
                            stacked: this.stacked,
                            ticks: {
                                beginAtZero: true,
                                userCallback: function(value, index, values) {
                                    value = value.toString();
                                    value = value.split(/(?=(?:...)*$)/);
                                    value = value.join(',');
                                    return value;
                                }
                            },
                            gridLines: {
                                zeroLineColor: "black",
                                zeroLineWidth: "3"
                            }
                        }],
                    },
                    plugins: {
                        datalabels: {
                            display: false,
                        },
                    }
                }
            }
        },
        methods: {

        }
    }
</script>